import classes from './Startup.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import {Link} from "react-router";
import arrowRight from '../../../media/icons/arrowRightBlack.svg'
import { useTranslation } from 'react-i18next';

const Startup = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = t('startupProductEngineeringExpertise.title')
    const description = t('startupProductEngineeringExpertise.text', {returnObjects: true})

    const blackBlocks = t('startupProductEngineeringExpertise.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('startupProductEngineeringExpertise.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('startupProductEngineeringExpertise.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('startupProductEngineeringExpertise.benefitBlocks', {returnObjects: true})

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
            left: t('startupProductEngineeringExpertise.Faq.left', {returnObjects: true}),
            right: t('startupProductEngineeringExpertise.Faq.right', {returnObjects: true}),
    };


    const cases = t('startupProductEngineeringExpertise.cases', {returnObjects: true})


    return (
        <main>
            <Heading title={title} description={description} maxWidth={800}/>

            <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                <div>
                    <h3>{t('startupProductEngineeringExpertise.blackBlocksTitle')}</h3>
                    <p>{t('startupProductEngineeringExpertise.blackBlocksText')}</p>
                </div>
                <div className={classes.blocks}>
                    {blackBlocks.map(({text, icon}) => (<BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                <div>
                    <h2>{t('startupProductEngineeringExpertise.challengesBlocksTitle')}</h2>
                    <p>{t('startupProductEngineeringExpertise.challengesBlocksText')}</p>
                </div>

                <div>
                    {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                     text={text} key={title}/>)}
                </div>
            </section>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('startupProductEngineeringExpertise.solutionsBlocksTitle')}</h2>
                    <p>{t('startupProductEngineeringExpertise.solutionsBlocksText')}</p>
                </div>

                <div>
                    {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                        <img alt={title} src={require(`./media/${image}`)}/>
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('startupProductEngineeringExpertise.benefitBlocksTitle')}</h2>
                </div>

                <div>
                    {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text} key={title}/>)}
                </div>
            </section>

            <section className={`section--white ${classes.cases}`} id="nav-dark">
                <h2>{t('startupProductEngineeringExpertise.casesTitle')}</h2>

                <div className={classes.blocks}>
                    {cases.map(({image, title, text, link}) =>
                        <div key={title} className={classes.block}>
                            <img src={require(`./media/${image}`)} alt={title}/>
                            <div className={classes.content}>
                                <h4>{title}</h4>
                                <div className={classes.label}>
                                    <span>{t('startupProductEngineeringExpertise.casesStartup')}</span>
                                </div>
                                <p className={classes.text}>{text}</p>
                            </div>
                            <Link className={classes['learn-more']} to={link}><span>{t('startupProductEngineeringExpertise.casesButton')}</span><img src={arrowRight} alt='arrow right'/></Link>
                        </div>)}
                </div>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard 
                        title={t('startupProductEngineeringExpertise.formCard.title')}
                        message={t('startupProductEngineeringExpertise.formCard.message')}
                        buttonText={t('startupProductEngineeringExpertise.formCard.buttonText')}
                        labels={t('startupProductEngineeringExpertise.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('startupProductEngineeringExpertise.Faq.title')} questions={questions}/>
            </section>
        </main>
);
};

export default Startup;
